// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"24349ef0","239":"0734578f","453":"d0f03e46","667":"2592fbb3"}[chunkId] + ".chunk.js";
};